export const CANDIDATE_MAPPING_STATUS_VALUES = {
  IN_SECONDARY: 'In Secondary',
  SCREENED: 'Screened',
  SUBMITTED: 'Submitted',
  SHORTLISTED: 'Shortlisted',
  REJECTED: 'Rejected',
  ON_HOLD: 'On Hold',
  PENDING_INTERVIEW: 'Pending Interview',
  OFFER_EXTENDED: 'Offer Extended',
  OFFER_ACCEPTED: 'Offer Accepted',
  JOINED: 'Joined',
  pending_interview: 'Pending Interview',
  offer_extended: 'Offer Extended',
  offer_accepted: 'Offer Accepted',
  submitted: 'Submitted',
  shortlisted: 'Shortlisted',
  rejected: 'Rejected',
  on_hold: 'On Hold',
  joined: 'Joined',
  screened: 'Screened',
  accepted: 'Accepted',
  pending: 'Pending',
  new: 'New',
  in_progress: 'In Progress',
  passed: 'Passed',
  failed: 'Failed',
};

export const BILLING_STATUS_VALUES = {
  DRAFT: 'Draft',
  PENDING_APPROVAL: 'Pending Approval',
  APPROVED: 'Approved',
  REVISED: 'Revised',
  CANCELED: 'Canceled',
  CANCELLED: 'Canceled',
  PENDING: 'Pending',
  SENT: 'Sent',
  PAID: 'Paid',
  PARTIALLY_PAID: 'Partially Paid',
  OVERDUE: 'Overdue',
  COMPLETED: 'Completed',
  PROCESSED: 'Processed',
  ISSUED: 'Issued',
  APPLIED: 'Applied',
  GENERATED: 'Generated',
  MODIFIED: 'Modified',
  PAYMENT_AWAITED: 'Payment Awaited',
};
